import useScrollPosition from '@react-hook/window-scroll'
import * as T from 'components/Typography'
import { darken } from 'polished'
import { useState } from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { isDevelopmentEnv, isStagingEnv } from 'utils/env'

import { ReactComponent as DarkLogo } from '../../assets/svg/kodiak-logo-default.svg'
import { ChainAwareLink, ExternalLink } from '../../theme'
import Menu from '../Menu'
import Row from '../Row'
import { BurgerButton, BurgerMenu } from './BurgerMenu'
import NavDropdown from './NavDropdown'
import NetworkSelector from './NetworkSelector'
import PortfolioLink from './PortfolioLink'
import { useSchema } from './Schema'
import Web3Status from './Web3Status'

const HeaderFrame = styled.div<{ showBackground: boolean }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  padding: 20px 80px;
  z-index: 21;
  position: relative;
  /* Background slide effect on scroll. */
  /* background-image: ${({ theme }) =>
    `linear-gradient(to bottom, transparent 50%, ${theme.backgroundSurface} 50% )}}`};
  background-position: ${({ showBackground }) => (showBackground ? '0 -100%' : '0 0')};
  background-size: 100% 200%; */

  background: ${({ theme }) => theme.backgroundSurface};
  box-shadow: 0px 0px 0px 1px ${({ theme, showBackground }) => (showBackground ? theme.deprecated_bg2 : 'transparent;')};
  transition: background-position 0.1s, box-shadow 0.1s;
  background-blend-mode: hard-light;

  border-bottom: 1px solid ${({ theme }) => theme.cardBorderPrimary};

  ${({ theme }) => theme.mediaWidth.upToExtraLarge`
    grid-template-columns: 48px 1fr 330px;
    padding: 20px 40px;
  `};

  ${({ theme }) => theme.mediaWidth.upToMediumLarge`
    padding: 20px 40px;
    grid-template-columns: 1fr 1fr;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding:  20px;
    grid-template-columns: 36px 1fr;
  `};
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;

  &:not(:first-child) {
    margin-left: 0.5em;
  }

  /* addresses safaris lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `};
`

const HeaderLinks = styled(Row)`
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex: 1 0 0;
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToMediumLarge`
      display: none;

  `}/* justify-self: center; */
  /* background-color: ${({ theme }) => theme.deprecated_bg0}; */
  /* width: max-content; */
  /* padding: 2px; */
  /* border-radius: 16px; */
  /* display: grid; */
  /* grid-auto-flow: column; */
  /* grid-gap: 10px; */
  /* overflow: auto; */
  /* align-items: center; */
  /* ${({ theme }) => theme.mediaWidth.upToExtraLarge`
    justify-self: start;
    `};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-self: center;
  `};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    z-index: 99;
    position: fixed;
    bottom: 0; right: 50%;
    transform: translate(50%,-50%);
    margin: 0 auto;
    background-color: ${({ theme }) => theme.deprecated_bg0};
    border: 1px solid ${({ theme }) => theme.deprecated_bg2};
    box-shadow: 0px 6px 10px rgb(0 0 0 / 2%);
  `}; */
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* background-color: ${({ theme, active }) => (!active ? theme.deprecated_bg0 : theme.deprecated_bg0)}; */
  border-radius: 6px;
  white-space: nowrap;
  width: 100%;
  height: 40px;

  :focus {
    border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  }
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: flex-end;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  gap: 8px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};

  :hover {
    cursor: pointer;
  }

  h2 {
    color: ${({ theme }) => theme.textPrimary};
    font-weight: 500;
    line-height: 32px;
    margin: 0;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        line-height: 25px;
        display: none;
  `};
  }
`

const KodiakIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }

  position: relative;
`
const DesktopControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.mediaWidth.upToMediumLarge`
    display: none;
  `}
`
const MobileControls = styled.div`
  display: none;

  ${({ theme }) => theme.mediaWidth.upToMediumLarge`
    display: flex;
  `}
`

// can't be customized under react-router-dom v6
// so we have to persist to the default one, i.e., .active
const activeClassName = 'active'

interface StyledNavLinkProps {
  $isActive?: boolean // Using $ prefix to avoid DOM attribute warning
  width?: string
}

export const StyledNavLink = styled(ChainAwareLink).attrs({ variant: 'nav' })<StyledNavLinkProps>`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => (props.$isActive ? props.theme.textPrimary : props.theme.textSecondary)};
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  /* padding: 8px 12px; */
  word-break: break-word;
  overflow: hidden;
  white-space: nowrap;
  gap: 2px;
  width: ${({ width }) => width};
  &.${activeClassName} {
    font-weight: 600;
    color: ${({ theme }) => theme.textPrimary};
  }
  :hover {
    color: ${({ theme }) => theme.textPrimary} !important;
  }
  :focus {
    color: ${({ theme }) => darken(0.1, theme.textPrimary)};
  }
`

export const StyledExternalLink = styled(ExternalLink)`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  gap: 2px;

  &.${activeClassName} {
    font-weight: 600;
    color: ${({ theme }) => theme.textPrimary};
  }

  :hover {
    color: ${({ theme }) => theme.textPrimary} !important;
  }

  :focus {
    color: ${({ theme }) => darken(0.1, theme.textPrimary)};
    text-decoration: none;
  }
`

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 0px;

  // position: relative;
`

export default function Header() {
  const scrollY = useScrollPosition()

  const schema = useSchema()
  const [openBurgerMenu, setOpenBurgerMenu] = useState(false)
  const toggleBurgerMenu = () => setOpenBurgerMenu((prev) => !prev)

  return (
    <HeaderWrapper>
      <HeaderFrame showBackground={scrollY > 45}>
        <Title href=".">
          <KodiakIcon>
            <DarkLogo height="30px" width="46.5px" title="logo" />
          </KodiakIcon>
          <T.HeadingM>Kodiak</T.HeadingM>
        </Title>

        <HeaderLinks>
          {schema.map((item) => {
            const hasSublinks = Array.isArray(item.sublinks) && item.sublinks.length > 0
            const to = item.to ?? item.href ?? ''

            return !hasSublinks ? (
              <StyledNavLink
                key={item.id}
                id={item.id}
                to={to}
                target={item.external ? '_blank' : undefined}
                className={item.isActive ? activeClassName : ''}
              >
                {item.label}
                {item.external && <sup>&nbsp;↗</sup>}
              </StyledNavLink>
            ) : (
              <NavDropdown key={item.id} name={item.name!} dropdownLinks={item.sublinks!}>
                <StyledNavLink
                  to={to}
                  id={item.id}
                  className={item.isActive && item.to ? activeClassName : ''}
                  target={item.external ? '_blank' : undefined}
                >
                  {item.label}
                </StyledNavLink>
              </NavDropdown>
            )
          })}
        </HeaderLinks>
        <HeaderControls>
          <MobileControls>
            <BurgerButton onClick={toggleBurgerMenu} opened={openBurgerMenu} />
          </MobileControls>

          <DesktopControls>
            <HeaderElement>
              <PortfolioLink />
            </HeaderElement>
            <HeaderElement>
              <Web3Status />
            </HeaderElement>
            <HeaderElement>
              <NetworkSelector menuAlignment="right" />
            </HeaderElement>
            {(isDevelopmentEnv() || isStagingEnv()) && (
              <HeaderElement>
                <Menu />
              </HeaderElement>
            )}
          </DesktopControls>
        </HeaderControls>
      </HeaderFrame>
      <BurgerMenu show={openBurgerMenu} onClose={() => setOpenBurgerMenu(false)} />
    </HeaderWrapper>
  )
}
